import { render, staticRenderFns } from "./ChooseItem.vue?vue&type=template&id=44ef9e0a&scoped=true"
import script from "./ChooseItem.vue?vue&type=script&lang=js"
export * from "./ChooseItem.vue?vue&type=script&lang=js"
import style0 from "./ChooseItem.vue?vue&type=style&index=0&id=44ef9e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ef9e0a",
  null
  
)

export default component.exports